<template>
    <div class="md:w-[400px] 2xl:w-[465px]  border-r px-5 my-1 sm:w-[320px] hidden lg:block"
         :class="moblieActive && activemoble ? 'show-siderbar top80':moblieActive && !activemoble ?'show-siderbar top40': 'relative'">
        <div @click="toggleShowMenu" class="closebtn cursor-pointer w-[46px] h-[46px] lg:hidden items-center justify-center -mr-4 group">
            <svg width="17"
                 height="17"
                 viewBox="0 0 17 17"
                 fill="none"
                 class="stroke-2 stroke-primary group-hover:stroke-primary"
                 style="z-index: 999;"
                 >
                <path d="M2 2L15 15M15 2L2 15"/>
            </svg>
        </div>
        <div class="w-full ">
            <div
                class="xl:text-[16px] 2xl:text-[20px] leading-snug flex items-center mb-4 xl:mb-0 xl:mr-3 whitespace-nowrap flex-shrink-0">
                <strong class="mr-2 my-4">Adjust Quantity or Budget</strong>
                <help-tip v-if="monetaryBudget != 1"
                          content="Adjust your lead quantity or budget by using the slider or entering a value in the Lead Quantity box"
                />
                <help-tip v-else
                          content="<div style='text-align: left !important'>Adjust your lead quantity or budget by:</br>
                            <ul style='list-style: disc;'><li>Using the slider</li>
                           <li> Entering a value in the Lead Quantity box</li>
                           <li> Entering a value in the Budget box</li> </ul>
                                </div>"
                />
            </div>
            <div  class="h-20 mt-8">
                <no-ui-slider v-model="sliderModel"
                              :max="maxCount"
                              :disabled="sliderDisabled"

                />
            </div>

        </div>

        <div class="form-group mb-4 w-full mt-2 lg:mt-0 w-full flex justify-content-between justify-between">
            <label class="w-50 text-[14px]">
                Lead Quantity
                <span class="text-[11px] text-gray-500 block" v-if="countLead && countLead >= minCount">
                    Enter from  {{ minCount | formatNumber("1,000") }} -
                                 {{ maxCount | formatNumber("1,000") }}
        </span>
                <span v-else class="text-[11px] text-gray-500 block">
             Not enough leads to purchase
          </span>

            </label>
            <div class="flex items-center justify-between shrink-0 mt-2 lg:mt-0">
                <input
                    type="text"
                    id="lead-quantity"
                    class="form-control disabled:cursor-not-allowed font-poppins w-[150px] 2xl:w-[170px]"
                    :max="maxCount"
                    v-model="quantity"
                    ref="preQuantity"
                    @keypress="isNumber"
                    @keydown="$event.keyCode === 38 || $event.keyCode === 40 ? $event.preventDefault() : false"
                    :disabled="countLead < minCount"
                />
            </div>
        </div>
        <div class="form-group mb-4 w-full mt-2 lg:mt-0 w-full flex justify-content-between justify-between">
            <label class="w-50 text-[14px]">
                Budget
                <span class="text-[11px] text-gray-500 block" v-if="monetaryBudget != 0">
                  Enter your budget
                </span>
            </label>
            <div class="flex items-center justify-between shrink-0 mt-2 lg:mt-0 input-icon budget" v-if="monetaryBudget != 0">
                <span class="font-poppins">$</span>
                <input
                    type="text"
                    id="lead-budget"
                    class="form-control disabled:cursor-not-allowed font-poppins w-[150px] 2xl:w-[170px]"
                    v-model="price"
                    @keypress="isNumber"
                    @keydown="$event.keyCode === 38 || $event.keyCode === 40 ? $event.preventDefault() : false"
                />
            </div>
            <div v-else class="flex items-center justify-between shrink-0 mt-2 lg:mt-0  text-[15px] font-bold">
                {{'$'+ price}}
            </div>
        </div>

        <div class="w-full">
            <div
                class="xl:text-[16px] 2xl:text-[20px] leading-snug  flex items-center mb-4 xl:mb-0 xl:mr-3 whitespace-nowrap flex-shrink-0">
                <strong class="mr-2 my-4">Order summary</strong>
            </div>
            <div class="p-5 my-4  rounded-lg" :class="moblieActive ? 'bg-white ': 'ordersummary' ">
                <div class="border-b-2 border-gray-300">
                    <div class=" flex justify-between text-[15px] font-light">
                        <label>Total leads </label>
                        <div>{{quantity}}</div>
                    </div>
                    <div class="border-dashed border-2 border-green-700 bg-white my-4 p-2 ">
                        <div v-if="firstpurches" class="text-green-700 text-center font-medium" @click="showPopup()" x-data="promoModal" :class="firstpurches ? 'cursor-pointer':''">

                            {{ firstpurches ? 'Click Here For 15% Off': 'Use Code DATA15 for 15% Off in next step' }}
                        </div>
                        <div v-else class="text-green-700 text-center font-medium">
                            Use Code DATA15 for 15% Off in next step
                        </div>
                    </div>
                    <hr class="bg-gray-400"/>
                </div>
                <div class="py-2 my-2">
                    <div class="flex justify-between my-3">
                        <div class="text-[15px] font-bold">
                            Total Price
                        </div>
                        <div class="text-[15px] font-bold">
                            {{'$'+ price}}
                        </div>
                    </div>

                    <div class="text-center">
                        <button
                            class="btn btn-orange bg-fully w-full my-2 lg:mt-0  h-[46px] uppercase relative"
                            @click="addToCart"
                            :disabled="disabledBuyButton">
                            Buy list
                        </button>
                        <div class="my-2">
                            <save-list v-if="saveListOn"/>
                        </div>


                    </div>
                </div>
            </div>
            <p class="my-2 text-[12px]">
                Need help? Visit our <a :href="$widgetConfig.faqUrl" target="_blank">FAQ</a> page
            </p>
        </div>
    </div>
</template>

<script>
import debounce from "lodash/debounce";
import { EventBus } from "@widget/plugins/event-bus";
import IconWarning from "@widget/components/icons/icon-warning";
import NoUiSlider from "@widget/components/ui/no-ui-slider";
import GlobalUtils from "@widget/utils/global";
import widgetData from "../store/widget-data";

export default {
    name: "right-sidebar",
    components: {
        NoUiSlider,
        IconWarning,
        SaveList: () => import("@widget/modules/saved-lists/save-list"),
    },
    computed: {
        moblieActive(){
            return this.$store.state.widgetData.showRightbar;
        },
        activemoble(){
            return window.activemoble;
        },
        firstpurches(){
            return window.firstpurches;
        },
        widgetData() {
            return widgetData
        },
        selectedData () {
            return this.$store.getters["widgetData/selectedData"];
        },
        countLead () {
            return this.$store.getters["calculateLeads/getCount"].total;
        },
        methodPay: {
            set (value) {
                this.$store.commit("calculateLeads/setCredit", {
                    key: "method",
                    value
                });
            },
            get () {
                return this.$store.getters["calculateLeads/getCredit"].method;
            }
        },
        quantity: {
            set: debounce(function (value) {
                if (Number(value) > this.maxCount) {
                    this.$store.commit("calculateLeads/setQuantity", this.maxCount);
                } else {
                    this.$store.commit("calculateLeads/setQuantity", Number(value));
                }
                this.$store.commit("widgetData/setUserChanged");

                this.getPrice();
            }, 1000),
            get () {
                return this.$store.getters["calculateLeads/getQuantity"];
            }
        },
        minCount () {
            return this.$store.getters["calculateLeads/getCount"].min;
        },
        maxCount () {
            return this.$store.getters["calculateLeads/getCount"].max;
        },
        loading () {
            return this.$store.getters["calculateLeads/getLoading"];
        },
        credit () {
            return this.$store.getters["calculateLeads/getCredit"];
        },
        price: {
            set: debounce(function (value) {
                this.$store.commit("calculateLeads/setPrice", Number(value));
                this.$store.commit("widgetData/setUserChanged");
                this.getQuantity();
            }, 2000),
            get () {
                return this.$store.getters["calculateLeads/getPrice"];
            }
        },
        sliderDisabled () {
            return this.maxCount < this.minCount;
        },
        disabledBuyButton () {
            return this.quantity < this.minCount || !this.userChanged;
        },
        additionalStyle () {
            let headerEl = document.getElementsByTagName("header")[0];
            if (headerEl) {
                return { top: `${headerEl.offsetHeight}px` };
            }
            return { top: 0 };
        },
        sliderModel: {
            set: debounce(function (value) {
                this.$store.commit("calculateLeads/setQuantity", Number(value));
                this.$store.commit("widgetData/setUserChanged");

                this.getPrice();
            }, 300),
            get () {
                return this.$store.getters["calculateLeads/getQuantity"];
            }
        },
        userChanged () {
            return this.$store.getters["widgetData/getUserChanged"];
        },
        monetaryBudget () {
            return this.$store.getters["calculateLeads/getMonetaryBudget"];
        },
        saveListOn () {
            return this.$widgetConfig.save_list;
        },
    },
    watch: {
        selectedData: {
            handler () {
                this.getCount();
            },
            deep: true
        }
    },
    methods: {
        toggleShowMenu(){
            this.$store.state.widgetData.showRightbar=false;
        },
        isNumber (event) {
            return GlobalUtils.isNumber(event);
        },
        addToCart () {
            if (parseInt(this.quantity) >= this.minCount) {
                //window.splitTrack("register_buy_list");
                this.$modal.show("modal-cart");
            }
        },
        async getPrice () {
            this.$store.commit("others/setLoading", true);

            await this.$store.dispatch("calculateLeads/getPrice");

            this.$store.commit("others/setLoading", false);
        },
        async getQuantity(){
            this.$store.commit("others/setLoading", true);

            await this.$store.dispatch("calculateLeads/getQuantity");

            this.$store.commit("others/setLoading", false);
        },
        async getCount () {
            this.$store.commit("others/setLoading", true);

            await this.$store.dispatch("calculateLeads/getCount");

            await this.getPrice();
        },
        async getMonetaryBudget(){
            await this.$store.dispatch("calculateLeads/getMonetaryBudget");
        },
        async showPopup () {
            await document.dispatchEvent(new CustomEvent("visible-modal", {
                detail: {
                    id: "promo-modal"
                },
                bubbles: true
            }));
        },

    },
    created () {
        this.getMonetaryBudget();
        this.getCount();
    },
    mounted () {
        EventBus.$on("focus-input-lead", () => {
            if (this.$refs.preQuantity) {
                this.$refs.preQuantity.focus();
            }
        });
    }
}
</script>

<style lang="scss" scoped>
.noUi-horizontal .noUi-tooltip{
    bottom: 0% !important;
}
.widget #widget-no-ui-slider .noUi-connect, #widget-modal #widget-no-ui-slider .noUi-connect, #buy-datacard-modal #widget-no-ui-slider .noUi-connect{
    background-color: #014A76 !important;
}


</style>
